import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import { SummaryPlayEventsWrapper } from '@gameday/components/Play/play/SummaryPlayEvents.style';
import { PlayPitchWrapper } from '@gameday/components/Play/play/PlayPitches.style';
import { PitchHeaderWrapper, CountWrapper } from '../Play/play/PlayPitches.style';
import { PlaySegDiv } from '../Play/LiveFeedPlay.style';
import { ATBAT_MODAL_BREAKPOINT, ATBAT_SHARE_MARGIN_BREAKPOINT } from '@gameday/components/themes/breakpoints';
import ControlledOverflow from '@mlb/react-patterns/v4/components/ControlledOverflow/controlledOverflow';
import { InnerWrapper } from '@mlb/react-patterns/v4/components/ControlledOverflow/controlledOverflow.style';
import { ShareWrapper } from '../Share/share.style';
import { FieldVisionPlayerContainer } from '@gameday/components/FieldVision/fieldvision.style';

const {
    mlbBlack
} = COLORS;

export const ModalTypes = {
    VERTICAL: 'vertical',
    MIDDLE: 'middle',
    FIELDVISION: 'fieldVision',
    FIELDVISION_VERTICAL: 'fieldVision_vertical',
    ATBAT: 'atbat',
    ATBAT_VERTICAL: 'atbat_vertical',
    GAME_OVER: 'gameOver',
    PORTAL_LESS: 'portalless',
    SCOREBOARD_VERTICAL: 'scoreboard_vertical',
    NO_OKTA: 'noOkta',
    INTERSTITIAL: 'interstitial'
};

export const AtBatWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    width: 100%;

    ${ShareWrapper} {
        padding-top: 4px;
        z-index: 1;
        padding-top: 0;
        float: right;
        margin-top: -11px;
        margin-right: 16px;
        color: var(--gameday-primary-font-color);

        @media (max-width: ${ATBAT_SHARE_MARGIN_BREAKPOINT}) {
            margin-right: 8px;
        }
    }

`;

export const ContentWrapper = styled.div`
    margin-top: 24px;
`;

export const TabsWrapper = styled.div`
    div {
        padding-bottom: 0;
    }
    button {
        color: var(--gameday-tab-button-inactive-color);
        border-bottom: 0;
        &:hover {
            border-bottom: 0;
        }
        &[data-selected=true] {
            color: var(--gameday-tab-button-active-color);
        }
        padding: 0;
        margin: 0 30px 0 0;

        &:last-child {
            margin-right: 0;
        }
    }
`;

export const FlexWrapper = styled.div`
  display: flex;
  height: 276px;
  overflow: hidden;
`;

export const PitchByPitchBaseWrapper = styled.div`
  overflow: hidden;
  isolation: isolate;

  .responsive-pitch-fx-ball {
    pointer-events: none;
  }

  ${SummaryPlayEventsWrapper}, ${PlayPitchWrapper} {
    margin-left: 0;
  }

  ${PlayPitchWrapper} {
      padding-left: 43.5px;

      @media (min-width: 529px) {
        margin-bottom: var(--gameday-section-padding-sm);
      }
  }

  ${PlaySegDiv} {
    margin-bottom:0;
    @media (max-width: ${ATBAT_MODAL_BREAKPOINT}) {
        margin-bottom: var(--gameday-section-padding-sm);
    }
    &:last-child {
        >div {
            margin-bottom: 0px;
        }
    }
  }
`;

export const PitchByPitchDesktopWrapper = styled(PitchByPitchBaseWrapper)`
  background: ${mlbBlack};
  width: 220px;
  height: 270px;
  border-radius: var(--gameday-border-radius);

  .field {
    transform: translate(-50%, -67%);
    margin: 100% 0 -14% 50%;
  }

  ${PlayPitchWrapper} {
    padding-left: 40px;
    width: 190px;
  }

`;

export const LiveFeedWrapper = styled(PitchByPitchBaseWrapper)`
    display: inline-block;
    width: 252px;
    height: 274px;
    margin-left: var(--gameday-section-padding-sm);
    overflow-x: hidden;
    overflow-y: auto;

    @media (max-width: ${ATBAT_MODAL_BREAKPOINT}) {
        margin-left:15px;
        width: 230px;
    }

    ${PitchHeaderWrapper} {
        width: calc(100% - 45.5px);
    }

    ${CountWrapper} {
        padding-right: 5px;
    }

`;

export const LiveFeedMobileWrapper = styled(PitchByPitchBaseWrapper)`
    display: inline-block;
    width: 100%;
    height: auto;
    margin-top: var(--gameday-section-padding-sm);

    ${SummaryPlayEventsWrapper}, ${PlayPitchWrapper} {
        margin-left: 0;
    }

    ${PitchHeaderWrapper} {
        width: calc(100% - 45.5px);
    }

`;

export const PitchByPitchMobileWrapper = styled(PitchByPitchBaseWrapper)`
  width: 100%;
  height: 300px;
  border-radius: var(--gameday-border-radius);
  margin-top: var(--gameday-section-padding-sm);

  .field {
    transform: translate(-50%, -68%);
    margin: 250px 0 -14% 50%;
  }

  ${PlayPitchWrapper} {
    padding-left: 40px;
    width: 100%;
  }
`;

export const VideoWrapper = styled.div`
    width: 100%;
    height: 276px;

    @media (max-width: ${ATBAT_MODAL_BREAKPOINT}) {
        margin-top: var(--gameday-section-padding-sm);
        height: auto;
    }

    a {
        width: 100%;
        margin: 0;
    }
`;

export const ScoreProbabilityWrapper = styled.div`
    margin: var(--gameday-section-padding-sm) 0px;
    >div {
        display: inline-block;
    }
`;

export const LinkWrapper = styled.button`
    background: none;
    color: inherit !important; // There's some button styling that needs to be overwritten
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    text-align: left;
`;

export const InfoDivider = styled.div`
    height: 1px;
    background-color: var(--gameday-divider-color);
`;

export const PlayDetailMediaWrapper = styled.div`
  width: 100%;
  height: ${({ isSingleVid }) => (isSingleVid ? 'auto' : '208px')};
  max-width: ${({ isSingleVid }) => (isSingleVid ? 'none' : '330px')};
  margin: ${({ isSingleVid }) => (isSingleVid ? '0' : '0 8px')};
`;

export const ControlledOverflowOverride = styled(ControlledOverflow)`
    ${InnerWrapper} {
        ${({ fvodFullscreen }) => fvodFullscreen ? 'overflow: visible;' : ''}
    }
    ${FieldVisionPlayerContainer} {
        > div {
            ${({ fvodFullscreen }) => fvodFullscreen ? 'z-index: 120!important;' : ''}
        };
    }
`;

export const DetailTitleWrapper = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    padding: var(--gameday-section-padding-sm) 0;
    border-radius: var(--gameday-border-radius) var(--gameday-border-radius) 0 0;
    background: var(--gameday-background-color);
    z-index: 112; // carousel buttons are 110 :/

    &:after {
        height: 1px;
        background: var(--gameday-divider-color);
        width: 100vw;
        content: '';
        position: absolute;
        bottom: 0;
    }

    ${ShareWrapper} {
        position: absolute;
        right: 48px;
        top: 21px;
    }

    span {
        font-size: 16px;
        font-weight: 700;
        color: var(--gameday-primary-font-color);
    }
`;
